import { Link } from "react-router-dom";
import { ArrowUp, Phone, Mail, MapPin, Clock, Facebook, Instagram } from "lucide-react";
import { PHONE, PHONE_LINK, EMAIL } from "@/components/Ui";

const prestations = [
  { label: "Maçonnerie à Bernay", href: "/maconnerie-bernay" },
  { label: "Maçonnerie à Évreux", href: "/maconnerie-evreux" },
  { label: "Rénovation à Bernay", href: "/renovation-bernay" },
  { label: "Rénovation à Évreux", href: "/renovation-evreux" },
  { label: "Gros œuvre", href: "/gros-oeuvre" },
  { label: "Parement brique", href: "/parement-brique" },
  { label: "Fondations", href: "/fondations" },
  { label: "Dalles et béton", href: "/dalles-beton" },
  { label: "Extension de maison", href: "/extension-maison" },
  { label: "Ouverture de mur porteur", href: "/ouverture-mur-porteur" },
  { label: "Béton & extérieurs", href: "/beton-amenagements-exterieurs" },
];

export default function Footer() {
  return (
    <footer className="relative bg-[#0A0A0A] border-t border-white/10 overflow-hidden pb-20 md:pb-0" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-20 pb-10 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div>
          <img src="/logo-header.png" alt="DMZ Normandie — Maçonnerie & rénovation" className="h-16 w-auto mb-5" />
          <p className="text-sm font-light text-zinc-500 leading-relaxed">
            Entreprise de maçonnerie générale, gros œuvre et rénovation. Bernay, Eure et Normandie.
          </p>
          <div className="flex gap-3 mt-6">
            <a href="https://www.facebook.com" target="_blank" rel="noreferrer" aria-label="Facebook" data-testid="footer-facebook"
              className="w-10 h-10 border border-white/15 rounded-full flex items-center justify-center text-zinc-400 hover:text-[#C4A484] hover:border-[#C4A484] transition-colors duration-300">
              <Facebook size={15} />
            </a>
            <a href="https://www.instagram.com" target="_blank" rel="noreferrer" aria-label="Instagram" data-testid="footer-instagram"
              className="w-10 h-10 border border-white/15 rounded-full flex items-center justify-center text-zinc-400 hover:text-[#C4A484] hover:border-[#C4A484] transition-colors duration-300">
              <Instagram size={15} />
            </a>
          </div>
        </div>

        <div>
          <p className="text-[10px] tracking-[0.4em] uppercase text-zinc-600 mb-4">Prestations</p>
          <div className="flex flex-col gap-3">
            {prestations.map((p) => (
              <Link key={p.href} to={p.href} className="text-sm font-light text-zinc-400 hover:text-[#C4A484] transition-colors duration-300" data-testid={`footer-${p.href.slice(1)}`}>
                {p.label}
              </Link>
            ))}
          </div>
        </div>

        <div>
          <p className="text-[10px] tracking-[0.4em] uppercase text-zinc-600 mb-4">Navigation</p>
          <div className="flex flex-col gap-3">
            <Link to="/" className="text-sm font-light text-zinc-400 hover:text-[#C4A484] transition-colors duration-300" data-testid="footer-nav-accueil">Accueil</Link>
            <Link to="/realisations" className="text-sm font-light text-zinc-400 hover:text-[#C4A484] transition-colors duration-300" data-testid="footer-nav-realisations">Réalisations</Link>
            <Link to="/zones" className="text-sm font-light text-zinc-400 hover:text-[#C4A484] transition-colors duration-300" data-testid="footer-nav-zones">Zones d'intervention</Link>
            <Link to="/a-propos" className="text-sm font-light text-zinc-400 hover:text-[#C4A484] transition-colors duration-300" data-testid="footer-nav-apropos">À propos</Link>
            <Link to="/contact" className="text-sm font-light text-zinc-400 hover:text-[#C4A484] transition-colors duration-300" data-testid="footer-nav-contact">Contact & devis</Link>
            <Link to="/mentions-legales" className="text-sm font-light text-zinc-400 hover:text-[#C4A484] transition-colors duration-300" data-testid="footer-nav-mentions-legales">Mentions légales</Link>
            <Link to="/confidentialite" className="text-sm font-light text-zinc-400 hover:text-[#C4A484] transition-colors duration-300" data-testid="footer-nav-confidentialite">Confidentialité</Link>
          </div>
        </div>

        <div>
          <p className="text-[10px] tracking-[0.4em] uppercase text-zinc-600 mb-4">Contact</p>
          <div className="flex flex-col gap-3">
            <a href={PHONE_LINK} className="text-sm font-light text-zinc-400 hover:text-[#C4A484] transition-colors duration-300 flex items-center gap-2" data-testid="footer-phone">
              <Phone size={13} className="text-[#C4A484]" /> {PHONE}
            </a>
            <a href={`mailto:${EMAIL}`} className="text-sm font-light text-zinc-400 hover:text-[#C4A484] transition-colors duration-300 flex items-center gap-2" data-testid="footer-email">
              <Mail size={13} className="text-[#C4A484]" /> {EMAIL}
            </a>
            <p className="text-sm font-light text-zinc-400 flex items-start gap-2">
              <MapPin size={13} className="text-[#C4A484] mt-1 shrink-0" /> 7 rue Jean de la Fontaine, 27000 Évreux — interventions à Bernay et en Normandie
            </p>
            <p className="text-sm font-light text-zinc-400 flex items-center gap-2">
              <Clock size={13} className="text-[#C4A484]" /> 24 h/24 — 7 j/7
            </p>
          </div>
        </div>
      </div>

      <div className="select-none pointer-events-none px-2" aria-hidden="true">
        <p className="font-serif-display font-light text-[26vw] leading-[0.8] text-white/[0.04] text-center tracking-tight -mb-[6vw]">DMZ</p>
      </div>

      <div className="border-t border-white/10 relative">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex items-center justify-between gap-3">
          <p className="text-xs font-light text-zinc-600">© {new Date().getFullYear()} DMZ Normandie — Tous droits réservés</p>
          <p className="hidden md:block text-xs font-light text-zinc-600">Maçonnerie · Gros œuvre · Rénovation — Bernay, Eure, Normandie</p>
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            data-testid="back-to-top-button"
            aria-label="Retour en haut"
            className="w-10 h-10 border border-white/15 rounded-full flex items-center justify-center text-zinc-400 hover:text-[#C4A484] hover:border-[#C4A484] transition-colors duration-300"
          >
            <ArrowUp size={15} />
          </button>
        </div>
      </div>
    </footer>
  );
}
